import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WonderTime from "@/pages/WonderTime";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WonderTime />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
